import React from "react";
import { Filter, PlusCircle } from "lucide-react";

interface PageActionsProps {
  onFilter: () => void;
  onAdd: () => void;
  addButtonText: string;
  activeFiltersCount?: number;
  showAddButton?: boolean;
}

const PageActions: React.FC<PageActionsProps> = ({
  onFilter,
  onAdd,
  addButtonText,
  activeFiltersCount = 0,
  showAddButton = true,
}) => {
  return (
    <div className="flex flex-col gap-2 px-4 sm:flex-row sm:items-center sm:gap-3 sm:px-0">
      <button
        onClick={onFilter}
        className="relative flex items-center justify-center gap-2 rounded-lg bg-neutral-600 px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-neutral-700 sm:px-4 sm:py-3 sm:text-base"
      >
        <Filter size={16} className="sm:size-[18px]" />
        Filtros
        {activeFiltersCount > 0 && (
          <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs text-white">
            {activeFiltersCount}
          </span>
        )}
      </button>
      {showAddButton && (
        <button
          onClick={onAdd}
          className="flex items-center justify-center gap-2 rounded-lg bg-primary px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-dark sm:px-6 sm:py-3 sm:text-base"
        >
          <PlusCircle size={16} className="sm:size-[18px]" />
          {addButtonText}
        </button>
      )}
    </div>
  );
};

export default PageActions;
